import { Tooltip, TooltipProps, tooltipClasses, Button, Modal, Box } from "@mui/material"
import { styled } from '@mui/styles';
import { QuizTitle } from "./QuizTitle";
import { useState } from "react";
import {InfoOutlined, Close} from '@mui/icons-material';
import { useTranslations } from "hooks";

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 450,
      boxShadow: '0px 0px 7px 2px #7494ae4a',
      fontSize: '14px',
      padding: '15px'
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#ef7909'
      },
  }));

export const QuizTooltip = ({text} : QuizTooltipType): JSX.Element => {
    const [open, setOpen] = useState(false);
    const handleOpen = (e:any) => {e.stopPropagation(); setOpen(true)};
    const handleClose = (e: any) => {e.stopPropagation(); setOpen(false)};
    const [TITLE, DETAIL] = useTranslations(i18n(text))
  
    return (<>
        <HtmlTooltip arrow placement="bottom-start" title={
            <div className="quizTooltip-content" onClick={(e:any) => e.stopPropagation()}>
                <span className="quizTooltip-text" dangerouslySetInnerHTML={{ __html: DETAIL }}>
                </span>
                <Button onClick={handleOpen}><InfoOutlined color="secondary" fontSize="small"/></Button>
            </div>
        }><strong>{TITLE} </strong></HtmlTooltip>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={styleModal} onClick={(e:any) => e.stopPropagation()}>
                <QuizTitle title="Définition" />
                <span className="modal-close" onClick={handleClose}><Close/></span>
                <div className="modal-img"><img src="/assets/img/b-10.png" alt="defintion" /></div>
                <div className="quizModal-content">
                    <p>
                        <strong>{TITLE}: </strong><span dangerouslySetInnerHTML={{ __html: DETAIL }}></span>
                    </p>
                </div>
            </Box>
        </Modal>
    </>)
}

const styleModal = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80vw',
    height: '80vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    zIndex: 99,
    overflow: 'auto'
  };

type QuizTooltipType = {
    text: string
}

const i18n = (text: string) => (
    [
        `MedicalDevice.Dictionary.${text}.title`,
        `MedicalDevice.Dictionary.${text}.detail`
    ]
)